import React from "react";
import moment from "moment";

import {component_tool} from '@/tool'

import {WizTableForm} from "@/containers/common";
import {Popover} from "antd";


const {WizModal} = component_tool

const pathConfig = WizTableForm.Config.path(this, {apiParams: {}})
const organizationConfig = WizTableForm.Config.organization(this, {apiParams: {state: 1}})
const positionConfig = WizTableForm.Config.position(this, {apiParams: {state: 1}})

//配置项
const componentName = 'learningScoreTrainPathResult';
const columns = (self) => {
  return [
    {
      title: '账号',
      name: "userName",
      searchItem: {},
      tableItem: {},
    },
    {
      title: '姓名',
      name: "fullName",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "路径名称",
      name: "pathIds",
      searchItem: {
        diy: WizTableForm,
        ...pathConfig,
      },
      tableItem: {
        dataIndex: 'pathName',
      },
      exportItem: {
        width: 30,
      },
    },
    {
      title: "路径类型",
      name: "pathType",
      dict: [
        {code: 0, codeName: '销售'},
        {code: 1, codeName: '售后'},
      ],
      searchItem: {
        type: 'select',
      },
      tableItem: {},
      exportItem: {
        width: 10,
      },
    },
    {
      title: '证书分类',
      name: "categoryName",
      tableItem: {},
      exportItem: {
        width: 25,
      },
    },
    {
      title: '任职',
      name: "identityList",
      tableItem: {
        render: (text, record) => {
          const list = text?.length ? text?.map(item => {
            const {orgName, orgCode, positionName, positionCode} = item || {}
            return <>{orgName}({orgCode})-{positionName}</>
          }) : []

          return (
            list?.length ?
              <Popover content={list?.map(view => <div>{view}</div>)}>
                {list[0]}
                {list.length > 1 ? <span style={{color: '#1790FF'}}>&nbsp;…</span> : undefined}
              </Popover> : '暂无任职'
          )
        }
      },
      exportItem: {
        width: 90,
        render: (text) => {
          return text?.map(item => {
            const {orgName, orgCode, positionName, positionCode} = item || {}
            return `${orgName}(${orgCode})-${positionName}`
          })?.join('\r\n')
        },
      },
    },
    {
      title: "组织名称",
      name: "orgIds",
      searchItem: {
        diy: WizTableForm,
        ...organizationConfig,
      },
    },
    {
      title: "岗位名称",
      name: "positionIds",
      searchItem: {
        diy: WizTableForm,
        ...positionConfig,
      },
    },
    {
      title: "等级",
      name: "levelList",
      dict: [
        {code: -1, codeName: '无等级'},
        {code: 0, codeName: 'LV1'},
        {code: 1, codeName: 'LV2'},
        {code: 2, codeName: 'LV3'},
        {code: 3, codeName: 'LV4'},
        {code: 4, codeName: 'LV5'},
        {code: 5, codeName: 'LV6'},
        {code: 6, codeName: 'LV7'},
        {code: 7, codeName: 'LV8'},
        {code: 8, codeName: 'LV9'},
      ],
      searchItem: {
        type: "select",
        mode: "multiple",
      },
      tableItem: {
        dataIndex: 'currentLevelName',
        render: (_, record) => {
          return record?.currentLevelName;
        }
      },
    },
    {
      title: '学习积分(总分)',
      name: "totalScore",
      tableItem: {},
    },
    {
      title: '学习积分(必修)',
      name: "requiredScore",
      tableItem: {},
    },
    {
      title: '学习积分(选修)',
      name: "electiveScore",
      tableItem: {},
    },
    {
      title: '业务积分',
      name: "bizRecordList",
      tableItem: {
        render: (text, record) => {
          const {pathType} = record || {}
          let bizRecordRender = dataValue => dataValue
          if (pathType === 0) bizRecordRender = dataValue => `${dataValue || 0}分`
          else if (pathType === 1) bizRecordRender = dataValue => `${dataValue > 0 ? '合格' : '不合格'}`

          return  text?.length ? text?.map(item => {
            const {date, brandName, dataValue, remark} = item || {}
            return `截止${date}：${bizRecordRender(dataValue)}${brandName || remark ? `（备注：${brandName}${remark}）` : undefined}`
          }).map(item => <div>{item}</div>) : ''
        },
      },
      exportItem: {
        width: 100,
        render: (text, record) => {
          const {pathType} = record || {}
          let bizRecordRender = dataValue => dataValue
          if (pathType === 0) bizRecordRender = dataValue => `${dataValue || 0}分`
          else if (pathType === 1) bizRecordRender = dataValue => `${dataValue > 0 ? '合格' : '不合格'}`

          return  text?.length ? text?.map(item => {
            const {date, brandName, dataValue, remark} = item || {}
            return `截止${date}：${bizRecordRender(dataValue)}${brandName || remark ? `（备注：${brandName}${remark}）` : undefined}`
          }).join('\r\n') : ''
        },
      },
    },
  ];
}

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        // btnAccessCheck: false,
        columns: columns(self),
        searchBarProps: {
          cols: {
            xs: 8,
            md: 8,
            xl: 8
          },
          wrappedComponentRef: self._wizTableList_searchRef,
          dataFormat: (v) => {
            const value = Object.assign({}, v)
            const {} = value || {}
            return value
          },
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            },
          ]
        },
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
        },
        modalFormProps: {},
        rowOperateProps: {
          // width: 80,
        },
        rowOperateSort: [],
        rowOperateView: [],
        commonOperate: {}
      }
    }
  };
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
}


let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {columns, reduxTemplateConfig, templateConfig};
